export default "__VITE_ASSET__75fb0af3__"